"use client";
import Link from "next/link";
import { MdError, MdErrorOutline, MdHome } from "react-icons/md";

export default function errorPage() {
  return (
    <div className="mt-2">
      <center>
        <h1 className="text-9xl text-base-content/10 mb-2">
          <MdErrorOutline className="w-48 h-48" />
        </h1>
        <h3 className="text-sm">Oups, quelque chose a mal tourné.</h3>
      </center>
      <div className="flex justify-center">
        <Link href="/" className="btn no-animation mt-4">
          Retourner à l&apos;accueil
        </Link>
      </div>
    </div>
  );
}
